import { Card } from "ui/components/card";
import { Separator } from "ui/components/separator";
import { Button } from "ui/index";
import { Icon } from "components"
import { PLUS } from "icons";

export function EvtIntegrationInputCard({ title, onClick, icon, type, disabled }) {
    return (
            <Card onClick={disabled ? undefined : onClick} key={title} className="h-max gap-0 py-1 border shadow-sm">
                <div className="p-4 md:p-6 space-y-4">
                    <div className="flex justify-between items-start">
                        <div className="text-foreground">
                            <Icon icon={icon} className="size-10" />
                        </div>
                    </div>
                    <div>
                        <h3 className="text-lg font-semibold">
                            {title}
                        </h3>
                    </div>
                </div>
                <Separator />
                <div className="px-4 md:px-6 py-4 flex justify-between items-center">
                <Button variant="default" className="gap-2" disabled={disabled}>
                        <Icon icon={PLUS} className="size-4 text-white" />
                        {type}
                    </Button>
                </div>
            </Card>
    )
}